import { ArticleEntityAdminService } from './articleEntityAdminService';
import { SuccessStory } from '@models/successStory';

export class SuccessStoryAdminService extends ArticleEntityAdminService<SuccessStory> {
    constructor() {
        super('/api/admin/success-story');
    }
}
